import { render, staticRenderFns } from "./tabs.component.vue?vue&type=template&id=bb6b6516&scoped=true"
import script from "./tabs.component.vue?vue&type=script&lang=ts"
export * from "./tabs.component.vue?vue&type=script&lang=ts"
import style0 from "./tabs.component.vue?vue&type=style&index=0&id=bb6b6516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b6516",
  null
  
)

export default component.exports